import React, { useContext } from 'react'
import './Navbar.css'
import logo from '../../Assests/images/avirTreckerLogo.png'
import Logout from '../Admin/Logout/Logout';
import { AuthContext } from '../Admin/AuthContext/AuthContext';
import { NavLink } from 'react-router-dom';

const Navbar = () => {
  const { userName, token } = useContext(AuthContext);
  const isLoggedIn = token !== "" && token !== null;

  return (
    <div className='navbarMain'>
      <div className="navbarSub">
        <div className="headerLogo">
          <img src={logo} alt="" />
        </div>

        {isLoggedIn && (
          <nav className="navLinks">
            <NavLink to="/applicationFormData" className="navLink">
              Dashboard
            </NavLink>
            <NavLink to="/createtreck" className="navLink">
              Create Link
            </NavLink>
            <NavLink to="/links" className="navLink">
              Manage Links
            </NavLink>
          </nav>
        )}

        <div className="profile">
          <h2 className='userNameHead'>{userName}</h2>
          {isLoggedIn && <Logout />}
        </div>
      </div>
    </div>
  )
}

export default Navbar